import { Field } from 'redux-form';
import ImageSelector from './ImageSelector';

const SelectImageField = (props) => {
    return (
        <Field
            name={props.name}
            component={ImageSelector}
            {...props}
        />
    );
}

export default SelectImageField;